const { cELM } = require("../../utils");

const RESOURCES_BASE_URL = process.env.MOBILE_APP ? 'https://s3.amazonaws.com/ui.healthnote.com' : '';

class Provider {
  constructor(params) {
    this._data = params.data;
    this.elm = cELM("div", "provider-block");
    this._name = "";
  }

  getHTML() {
    let html = `<div class="provider-logo"/></div>`;

    if (this._data.icon) {
      html = `<div class="provider-logo question-icon-${this._data.icon}" style="background: url('${RESOURCES_BASE_URL}/images/questionnaire/system/${this._data.icon}.svg'); background-position: center; background-repeat: no-repeat; background-size: cover;"/></div>`;
    }
    if (this._name) {
      html += `<div class="provider-text">${this._name}</div>`;
    }

    this.elm.innerHTML = html.trim();
    return this.elm;
  }
}

module.exports = Provider;
